import { object, string, boolean } from "yup";

const addStaffOnSiteSchema = object({
  name: string()
    .trim()
    .required("Staff name is required"),
  cotcQualified: boolean()
});

export default addStaffOnSiteSchema;
